import React from 'react'
import Link from 'next/link'
import config from '../../config.json'
import { useTranslation } from 'react-i18next'

const AirdropCard = ({ airdrop }) => {
    const { t } = useTranslation('common')
    const {
        airdropId,
        creator,
        displayData,
        minAmount,
        snapshotTime,
        token,
        logo,
    } = airdrop

    let previewImage, description, name

    const snapshotTimeFormatted =
        new Date(snapshotTime * 1000).toLocaleDateString() +
        ' ' +
        new Date(snapshotTime * 1000).toLocaleTimeString()

    if (displayData) {
        try {
            const data = JSON.parse(displayData.replace('"T"', '\\"T\\"'))
            previewImage = data['preview_img'].includes('http')
                ? data['preview_img']
                : data['preview_img']
                ? config.ipfs + data['preview_img']
                : ''
            name = data['name']
            description = data['description']
        } catch (e) {
            console.error('Invalid Json Data')
        }
    }

    return (
        <Link href={`/airdrop/${airdropId}`}>
            <div className=" max-w-[1300px] p-4 rounded-xl flex flex-col hover:bg-gray-300 hover:dark:!bg-black hover:scale-[1.02] gap-3 md:gap-2">
                <div className="">
                    {previewImage ? (
                        <img
                            src={previewImage}
                            width={300}
                            height={300}
                            className="rounded-lg w-full h-[200px] object-cover"
                        />
                    ) : (
                        ''
                    )}
                </div>
                <div className="mt-2">
                    <div className="flex flex-col gap-3 ">
                        <h2 className=" text-[18px] font-bold text-black dark:!text-white  line-clamp-2">
                            {name}
                        </h2>

                        <p className=" text-sm font-normal dark:!text-[#FFFFFFB3] text-black line-clamp-3">
                            {token}
                        </p>

                        <p className=" text-sm font-normal dark:!text-[#FFFFFFB3] text-black line-clamp-3">
                            {t('airdrops.for_holders_of_x', { x: minAmount })}
                        </p>

                        <div className="flex justify-start mt-1">
                            {logo ? (
                                <img
                                    src={logo}
                                    width={36}
                                    height={36}
                                    className="rounded-lg w-[36px] h-[36px] object-cover mr-4"
                                />
                            ) : (
                                ''
                            )}
                            <div className="">
                                <p className="text-sm font-medium text-gray-400">
                                    {t('airdrops.by_x', { x: creator })}
                                </p>
                                <p className="text-sm text-gray-400">
                                    {t('airdrops.snapshot_at')}:{' '}
                                    {snapshotTimeFormatted}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}
export default AirdropCard
